import type { fhirR4 } from '@smile-cdr/fhirts';
import { Status } from '../models/Status';
import { Detail } from '../models/Detail';
import { PersistentError } from '../models/PersistentError';

export interface AppState {
  appStatus: AppStatus;
  saveStatus?: Status;
  landing: {
    stages;
    currentStage: number;
  };
  submit: {
    stages;
    currentStage: number;
  };
  persistentError?: PersistentError;
  reqFieldCounter;
  logError?;
  questionnaire?: fhirR4.Questionnaire;
  questionnaireResponse?: fhirR4.QuestionnaireResponse;
  populateError?;
  task?: fhirR4.Task;
  autoSave: boolean;
  detail?: Detail;
  hasValidationError?: boolean;
}

export enum AppStatus {
  INIT,
  INPROGRESS,
  SUBMITTING,
  DONE,
}
